import { topTrucksQuery_marketBySlug_marketTopTrucks } from 'components/pages/TopTrucksPage/types/topTrucksQuery'
import Image from 'components/Image'
import { flatten, uniq } from 'lodash'
import ButtonLink from 'components/ui/ButtonLink'
import Link from 'next/link'

const Truck = ({
  truck
}: {
  truck: topTrucksQuery_marketBySlug_marketTopTrucks
}) => {
  const foodTypes = flatten(
    truck.truck.menus.map((m) => {
      return m.foodTypes.map((t) => t.name)
    })
  )

  return (
    <div className="relative bg-white py-8 lg:py-16 even:bg-gray-50 w-full max-w-none group">
      <div className="lg:mx-auto lg:max-w-7xl px-4">
        <div className="lg:grid lg:grid-cols-2 lg:gap-24 lg:items-start">
          <div className="relative mx-auto max-w-md sm:max-w-3xl">
            <div className="pt-12 sm:pt-16 lg:pt-20">
              <Link href={truck.truck.schedulePath} prefetch={false}>
                <h2 className="hover:text-gray-800 hover:underline duration-200 transition-all text-3xl text-gray-900 font-extrabold tracking-tight sm:text-5xl">
                  #{truck.position + 1}: {truck.truck.name}
                </h2>
              </Link>
              <div className="-mx-2 mt-2">
                {uniq(foodTypes).map((t) => (
                  <div
                    key={t}
                    className="flex-shrink-0 inline-block px-2 py-0.5 mx-2 my-0.5 text-orange-800 text-sm font-medium bg-orange-100 rounded-full"
                  >
                    {t}
                  </div>
                ))}
              </div>
              <div className="mt-6 text-gray-500 space-y-6 prose prose-lg">
                <div
                  className="text-gray-700"
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{ __html: truck.description?.html }}
                />
              </div>
            </div>
          </div>

          <div className="relative sm:py-16 mx-auto max-w-md sm:max-w-3xl lg:max-w-none lg:py-20 mt-4 lg:mt-0">
            <div className="relative rounded-2xl shadow-xl overflow-hidden flex">
              <Image
                alt={truck.truck.name}
                className="object-cover object-center"
                height={800}
                src={truck.truck.image.high}
                width={800}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-orange-600 via-orange-600 opacity-30 mix-blend-multiply" />
            </div>
          </div>
        </div>

        <div className="mt-10 sm:py-16 lg:py-0">
          <div className="grid grid-cols-3 lg:grid-cols-6 gap-x-4 lg:gap-x-6 gap-y-4 lg:gap-y-0">
            {truck.featuredItems.map((item) => (
              <div key={item.id} className="relative">
                <div className="shadow rounded-lg flex overflow-hidden">
                  <Image
                    alt={item.name}
                    className="object-cover w-full object-center"
                    height={200}
                    src={item.image.medium}
                    width={200}
                  />
                </div>
                <div>
                  <p className="mt-2 font-medium text-xs lg:text-sm text-center text-gray-800">
                    {item.name}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-max mx-auto mt-12 lg:mt-24 mb-10">
          <ButtonLink
            color="primary"
            href={truck.truck.schedulePath}
            prefetch={false}
            size="large"
            target="_blank"
            variant="contained"
          >
            Schedule & Menu
          </ButtonLink>
        </div>
      </div>
    </div>
  )
}

export default Truck
